export const IRREGULAR_SUPPLIERS_CACHE_KEY = 'irregular-suppliers-datagrid'
export const FEATURE_ROOT_PATH = 'irregular-suppliers'
